import { Component, computed, inject, input, output } from '@angular/core';
import { ButtonComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';
import { formatCancelDeadlineDate } from '../../utils/format-get-labels-dates';

/**
 * Get Labels footer: Cancel Shipment (OM-69) and Create A New Shipment (OM-66 AC6).
 */
@Component({
  selector: 'app-get-labels-actions',
  imports: [ButtonComponent, TranslatePipe, TypographyComponent],
  templateUrl: './get-labels-actions.html',
  styleUrl: './get-labels-actions.scss',
})
export class GetLabelsActions {
  private readonly translation = inject(TranslationService);

  readonly cancelDeadlineLocal = input.required<string>();
  /** When false, Cancel Shipment is hidden (past deadline or already cancelled). */
  readonly cancelAvailable = input(true);
  readonly createNewShipment = output<void>();
  readonly cancelRequested = output<void>();

  protected readonly formattedDeadline = computed(() =>
    formatCancelDeadlineDate(this.cancelDeadlineLocal(), this.translation.locale()),
  );

  /**
   * Asks the page to open the cancel confirmation dialog.
   */
  protected onCancel(): void {
    if (!this.cancelAvailable()) {
      return;
    }
    this.cancelRequested.emit();
  }

  /**
   * Emits so the page can clear session state and start a new wizard flow.
   */
  protected onCreateNew(): void {
    this.createNewShipment.emit();
  }
}
